export default class MoreFeatures extends React.PureComponent

  render: ->
    classes = "more-features"
    classes += " d-none" if !@props.visible

    <>
      <div className={classes}>
        <hr/>

        <h4>
          {@props.i18n.title}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle-check" />
            {@props.i18n.formalInformal}
          </li>
          <li>
            <i className="far fa-circle-check" />
            <a href="/blog/select-alternative-words-and-sentences" target="_blank">
              {@props.i18n.fineTuned}
            </a>
          </li>
          <li>
            <i className="far fa-circle-check" />
            <a href="/blog/proofreading-write-improve-source-text" target="_blank">
              {@props.i18n.proofreading}
            </a>
          </li>
        </ul>
      </div>

      { @renderMoreFeaturesToggler() }
    </>

  renderMoreFeaturesToggler: ->
    if @props.visible
      label = @props.i18n.showLess
      icon  = "fas fa-angle-up"
    else
      label = @props.i18n.viewMore
      icon  = "fas fa-angle-down"

    <button className="btn btn-link more-features-toggler"
            type="button"
            onClick={@props.toggle}>
      {label}
      <i className={icon} />
    </button>
